export const purifyConfig = {
    ALLOWED_TAGS: ['p', 'table', 'th', 'tr', 'td', 'strong', 'b', 'u', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'span'],  // 只允许这些标签
    FORBID_TAGS: ['script', 'style'], // 禁止 script 和 style 标签

    // ALLOWED_ATTR: ['href', 'title'], // 只允许这些属性
    // FORBID_ATTR: ['onclick', 'onerror'] // 禁止事件属性
}